import { render, staticRenderFns } from "./FilterSourceStudy.vue?vue&type=template&id=3256c4e2&"
import script from "./FilterSourceStudy.vue?vue&type=script&lang=js&"
export * from "./FilterSourceStudy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports